class ShippingQuote extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.shipping-input');
    this.button = this.querySelector('button[type="submit"]');
    this.loadingSpinner = this.button.querySelector('.loading__spinner');
    this.errorMessage = this.querySelector('.msg-error');
    this.address = this.querySelector('.address');
    this.shippingQuotes = this.querySelector('.shipping-quotes');
    this.baseUrl = window.Shopify?.routes?.root || '/';
  }

  connectedCallback() {
    //Input Listener para aplicar a máscara do cep
    this.input.addEventListener('input', () => {
      // Remove tudo que não for dígito
      let maskedValue = this.input.value.replace(/\D/g, '');

      // Limita a 8 dígitos (sem o '-')
      if (maskedValue.length > 8) {
        maskedValue = maskedValue.substring(0, 8);
      }

      // Aplica a máscara: XXXXX-XXX (se tiver 5+ dígitos)
      if (maskedValue.length > 5) {
        maskedValue = maskedValue.replace(/^(\d{5})(\d{0,3})/, '$1-$2');
      }

      this.input.value = maskedValue;
    });

    //Acionado no clique - valida o cep digitado antes de iniciar
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.hideError();

      const value = this.input.value.trim();
      // Remove hífen para validação
      const cleanValue = value.replace(/-/g, '');

      // Confirma se tem 8 dígitos
      if (/^\d{8}$/.test(cleanValue)) {
        this.getShipping(cleanValue);
      } else {
        this.showError('CEP inválido! Deve ter 8 dígitos.');
      }
    });
  }

  //Controlam mensagens de erro
  hideError() {
    this.input.classList.remove('error');
    this.errorMessage.classList.add('hidden');
  }
  showError(msg) {
    this.input.classList.add('error');

    this.errorMessage.innerHTML = `
            <span>
                <strong>${msg}</strong>
            </span>
            `;

    this.errorMessage.classList.remove('hidden');
    this.address.classList.add('hidden');
    this.shippingQuotes.classList.add('hidden');
    this.hideLoading();
  }

  //Controlam visual do Carregamento
  hideLoading() {
    if (!this.loadingSpinner) return;

    this.loadingSpinner.classList.add('hidden');
    this.button.querySelector('span').classList.remove('hidden');
  }
  showLoading() {
    if (!this.loadingSpinner) return;

    this.loadingSpinner.classList.remove('hidden');
    this.button.querySelector('span').classList.add('hidden');
  }

  //Atualiza visual com informações do endereço - somente se for possível o preenchimento
  updateAddress(address) {
    let strAddress = '';

    if (address?.logradouro) strAddress += address.logradouro;
    if (address?.bairro) strAddress += strAddress !== '' ? `, ${address.bairro}` : address.bairro;
    if (address?.localidade) strAddress += strAddress !== '' ? ` - ${address.localidade}` : address.localidade;
    if (address?.uf) strAddress += strAddress !== '' ? `, ${address.uf}` : address.uf;

    if (strAddress !== '') {
      this.address.innerHTML = `<span>${strAddress}</span>`;
      this.address.classList.remove('hidden');
    } else {
      this.address.classList.add('hidden');
    }
  }

  //Renderiza as opções de frete
  renderShippingQuotes(shippingQuotes) {
    //Retira o resultado anterior (se houver) e esconde a div até que todos os itens sejam carregados
    this.shippingQuotes.textContent = '';
    this.shippingQuotes.classList.remove('hidden');

    //Para cada opção de frete - criar e inserir um <li> com as informações
    shippingQuotes.forEach((quote) => {
      const deliveryTime = quote.delivery_days[0] != 1 ? 'dias úteis' : 'dia útil';

      const price = quote.price > 0 ? `R$ ${quote.price.toString().replace('.', ',')}` : 'Grátis';

      //Modo de configurar nome para transportadora padrão
      let presentment_name = `<span class="shipping-carrier-title">
                    <strong>
                    ${quote.presentment_name.trim()}
                    </strong>
                </span>`;

      //Caso ela tenha retirada em loja
      //Talvez seja bom trocar o RETIRAR por algo que possamos alterar nas configurações do painel
      //Caso seja diferente em outra transportadora
      //Pior que acontece é o nome gigante, somente
      if (quote.presentment_name.includes('RETIRAR')) {
        const wordParts = quote.presentment_name.split('|');

        let temp = '';
        for (const [index, part] of wordParts.entries()) {
          if (part.includes('RETIRAR')) {
            temp += `<span class="shipping-carrier-title">
                                <strong>
                                ${part.trim()}
                                </strong>
                            </span>`;
            continue;
          }
          if (index > 1) {
            temp += `<span class="shipping-carrier-store-detail">${part.trim()}</span>`;
            continue;
          }
          temp += `<span class="shipping-carrier-store">${part.trim()}</span>`;
        }
        presentment_name = temp;
      }

      const item = `
                <li class="shipping-quote">
                    <div class="shipping-carrier">
                        ${presentment_name}
                        <small>${quote.delivery_days[0]} ${deliveryTime}</small>
                    </div>
                    <div class="shipping-price">
                        <span>
                            <strong>
                                ${price}
                            </strong>
                        </span>
                    </div>
                </li>
                `;
      this.shippingQuotes.insertAdjacentHTML('beforeend', item);
    });
  }

  //Lógica principal
  async getShipping(cep) {
    try {
      //Controle visual (inicia loadingSpinner e esconde resultados anteriores)
      this.showLoading();
      this.shippingQuotes.classList.add('hidden');
      this.address.classList.add('hidden');

      //Pega o endereço para verificar se o mesmo existe
      //E para que o cliente possa confirmar que está correto
      const address = await this.getCEP(cep);
      if (!address || address?.erro) {
        this.showError('CEP informado é inválido.');
        return;
      }
      //Renderiza na tela
      this.updateAddress(address);

      //Pegar itens atuais do carrinho e já usá-los como backup (se houver)
      const cartItems = await this.getCart();
      //Adiciona pelo menos uma quantidade de itens ao carrinho, para frete atualizado (pega dados do form de produto)
      await this.addTempItems();

      //Valores
      const shippingQuotes = await this.getShippingQuote(cep, address.uf);

      //Limpar carrinho (reset)
      await this.clearCart();

      //Readicionar produtos do carrinho anterior, se houver
      if (cartItems?.length) {
        await this.updateCart(cartItems);
      }

      //Renderizar opções de frete e finalizar loadingSpinner
      console.log('shippingQutoes', shippingQuotes);
      this.renderShippingQuotes(shippingQuotes);
      this.hideLoading();
    } catch (e) {
      console.error('Error: ', e);
      this.showError('Erro: verifique o CEP e tente novamente.');
    }
  }

  //Chamada API para limpar (todo) o carrinho
  //Poderia estar num Service em separado para melhor manutenção (CartService)
  clearCart() {
    return fetch(`${this.baseUrl}cart/clear.js`)
      .then((response) => {
        if (!response.ok) {
          console.error('Erro na requisição');
          throw new Error();
        }
      })
      .catch((e) => console.error('Error:', e));
  }

  //Caso estejamos na página de produtos
  //Adicionar ao carrinho o item atual para cálculo correto do frete
  //Poderia estar num Service em separado para melhor manutenção (CartService)
  async addTempItems() {
    const formElement = this.closest('.product-page')?.querySelector('form[action*="/cart/add"]');
    if (!formElement) return null;

    const formData = this.getFormData(formElement);
    const results = await this.updateCart(formData);
  }

  //Atualizar o carrinho, adicionando elemento ou elementos
  //Poderia estar num Service em separado para melhor manutenção (CartService)
  updateCart(items) {
    //Se um vetor de items
    if (items?.length) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .catch((e) => {
          console.error('Erro:', e);
          return null;
        });
    }
    //Se somente um item
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(items),
    })
      .then((response) => response.json())
      .catch((e) => {
        console.error('Erro:', e);
        return null;
      });
  }

  //Pega as opções de frete utilizando a própria Shopify através da AJAX API (https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates);
  //Exemplo de URL: cart/shipping_rates.json?shipping_address[zip]=CEP&shipping_address[country]=PAÍS&shipping_address[province]=ESTADO ou DISTRITO
  //Poderia estar num Service em separado para melhor manutenção (shippingService)
  getShippingQuote(cep, province) {
    const paramsUrl = `cart/shipping_rates.json?shipping_address[zip]=${cep}&shipping_address[country]=BR&shipping_address[province]=${province}`;
    return fetch(`${this.baseUrl}${paramsUrl}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        if (data.shipping_rates.length > 0) {
          return data.shipping_rates;
        }
        return null;
      })
      .catch((e) => console.error('Error: ', e));
  }

  //Faz requisição a VIACEP para validação e utilizar endereço do cliente (estado/distrito)
  //Poderia ser utilizada a BRASILAPI, mas os atributos seriam outros, ex: resultado.estado seria resultado.province
  //Para realizar a troca deve ser reescrita essa parte no getShippingQuotes ou fazer com que seja genérica o bastante para ambos.
  //Poderia estar num Service em separado para melhor manutenção (AddressService?)
  getCEP(value) {
    return fetch(`https://viacep.com.br/ws/${value}/json/`)
      .then((response) => response.json())
      .then((data) => {
        if (!data.erro) {
          return data;
        }
      })
      .catch((e) => console.error('Error na validação ', e));
  }

  //Pega os itens atuais do Cart (que serão re-adicionados posteriormente)
  //Poderia estar num Service em separado para melhor manutenção (CartService)
  getCart() {
    return fetch(`${this.baseUrl}cart.js`)
      .then((response) => {
        if (!response.ok) throw new Error('Falha ao carregar carrinho');
        return response.json();
      })
      .then((dataTransfer) => {
        if (!dataTransfer.items || dataTransfer.items.length === 0) {
          return null;
        }
        return dataTransfer.items;
      })
      .catch((e) => console.error('Erro ao carregar o carrinho: ', e));
  }

  //Função Genérica para transformar valores do formulário em um Objeto.
  //Pode (e talvez deva) ser implementada no Utils
  getFormData(form, options = {}) {
    const { includeEmpty = false, transform } = options;
    const formData = new FormData(form);
    const result = {};

    formData.forEach((value, key) => {
      // Handle empty values
      if (!includeEmpty && (value === '' || value === null || value === undefined)) {
        return;
      }

      // Apply transform function if provided
      const processedValue = transform ? transform(key, value) : value;

      // Handle multiple values for same key (e.g., checkboxes)
      if (key in result) {
        if (Array.isArray(result[key])) {
          result[key].push(processedValue);
        } else {
          result[key] = [result[key], processedValue];
        }
      } else {
        result[key] = processedValue;
      }
    });

    return result;
  }
}

//Inicialização padrão de elemento HTML personalizado
if (!customElements.get('shipping-quote')) {
  try {
    customElements.define('shipping-quote', ShippingQuote);
  } catch (err) {
    console.error('Element already defined:', err);
  }
}
